import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  currentStep: 1,
  guidURL: '',
  idOffer: 0,
  idc: 0,
  partnerId: 0,
  orderId: '',
  accessToken: '',
  trackerClickId: '',
  idOperation: '',
  referenceNumber: '',
  offer: null,
  precontract: null,
  error: null,
  offerDetail: null,
  createOperationData: null,
  idRequestInstanstor: null,
  documentsRequired: null,
  identification: null,
  completedUrlDocument: null,
  completedMessage: null,
  statusKo: null,
  amazonChannel: false,
  legalConditions: null,
  componentsCMS: null,
  insuranceTypes: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
